import axios from "axios";

import config from "./config";

export default class Calculo {
  static async calcular(carteira, procedimento) {
    const bodyFormData = new FormData();
    bodyFormData.append("servico", "simularCalculo");
    bodyFormData.append("codusu", carteira);
    bodyFormData.append("codpro", procedimento);
    bodyFormData.append("presta", "000676");

    let response = "";
    try {
      response = await axios.post(config.API_URL_BASE, bodyFormData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
    } catch (err) {
        return {status: false, error:err};
    }
    return response.data
  }
}
